// extracted by mini-css-extract-plugin
export default {"modalWrapper":"SelectedStudents_modalWrapper__NWl-B","header":"SelectedStudents_header__NbU1B","title":"SelectedStudents_title__nhAZB","list":"SelectedStudents_list__KTq+m"};